import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import { COMMON } from '@sondermind/constants';

import { IrisButtonTypes } from '@sondermind/iris/button';
import { IconSizes } from '@sondermind/iris/icon';

import { InfoLinks } from '@sondermind/core/enums/info-links.enum';

@Component({
  selector: 'client-faq-accordion',
  templateUrl: './faq-accordion.component.html',
  styleUrls: ['./faq-accordion.component.scss'],
  standalone: false
})
export class FAQAccordionComponent implements OnInit {
  readonly iconSizes = IconSizes;

  @Input() isMobile: boolean = false;
  @Input() accountComplete: boolean = false;
  @Input() paymentInfoOnly: boolean = false;
  @Input() paymentSetupView: boolean = false;
  @Input() isProposeATime: boolean = false;

  paymentLink: string = InfoLinks.INSURANCE_AND_PAYMENT_FAQS;
  firstSessionFAQLink: string = InfoLinks.CLIENT_FIRST_SESSION_FAQ;
  rightTherapistLink: string = InfoLinks.CLIENT_FINDING_RIGHT_THERAPIST;
  testimonialLink: string = InfoLinks.CLIENT_TESTIMONIAL;
  supportPhoneLink = COMMON.SUPPORT_PHONE_THERAPY_LINK;
  supportPhoneDisplay = COMMON.SUPPORT_PHONE_THERAPY_DISPLAY;
  howItWorksPanelOpenState: boolean = false;
  rightTherapistPanelOpenState: boolean = false;
  whatUsedForPanelOpenState: boolean = false;
  whySonderMindPanelOpenState: boolean = false;
  pendoIdSuffix: string = '';
  IrisButtonTypes = IrisButtonTypes;

  ngOnInit(): void {
    this.pendoIdSuffix = this.accountComplete ? 'comp' : 'inc';
  }
}
